module.exports = __webpack_public_path__ + "static/media/demographics.8cf5c7be.svg";